import createReducer from '../createReducer';
import {
  FETCH_REGION_BY_SLUG,
  FETCH_REGION_BY_SLUG_SUCCESS,
  FETCH_REGION_BY_SLUG_FAILURE,
  FETCH_REGION_BY_COORDINATES,
  FETCH_REGION_BY_COORDINATES_SUCCESS,
  FETCH_REGION_BY_COORDINATES_FAILURE,
 } from '../../actions/cms/region';

const initialState = {
  region: {},
};

const handlers = {};

handlers[FETCH_REGION_BY_SLUG] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_REGION_BY_SLUG_SUCCESS] = (state, { region }) => ({
  ...state,
  loading: false,
  region,
});

handlers[FETCH_REGION_BY_SLUG_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_REGION_BY_COORDINATES] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_REGION_BY_COORDINATES_SUCCESS] = (state, { region }) => ({
  ...state,
  loading: false,
  region,
});

handlers[FETCH_REGION_BY_COORDINATES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/cms/region.js